import React, { Component } from 'react';
import {Carousel, Col} from 'react-bootstrap';
import Propiedad from '../../containers/Sections/Propiedades/propiedad';
import Spinner from '../Spinner';
import Slider from 'react-slick';

export default class SliderHomeResponsive extends Component {
	next(e) {
		e.preventDefault();
		e.stopPropagation();
  	this.refs.slider2.slickNext()
  }
  previous(e) {
		e.preventDefault();
		e.stopPropagation();
    this.refs.slider2.slickPrev()
  }

  render () {

    const { items } = this.props

		const settings = {
      className: "properties-slider-list",
      dots: false,
			lazyLoad: true,
			arrows: false,
      speed: 400,
			autoplay: false,
      slidesToShow: 1,
      slidesToScroll: 1,
			touchMove: false,
			swipeToSlide: false
		}

    if (items.length) {
      return (
        <div className="carousel-container">
          <Slider className="properties-slider-list" ref='slider2' {...settings}>
            {items.map((item, index) =>
                <Col sm={12} key={index}>
                  <Propiedad property={item} />
                </Col>
            )}
          </Slider>
					<div className="properties-slider-buttons">
            <div className="properties-left-buttons">
              <a onClick={(e) => {this.previous(e)}}>
                <i className="fa fa-angle-left fa-2x" aria-hidden="true"></i>
              </a>
            </div>
            <div className="properties-right-buttons">
              <a onClick={(e) => {this.next(e)}}>
                <i className="fa fa-angle-right fa-2x" aria-hidden="true"></i>
              </a>
            </div>
          </div>
        </div>
      )
    }
    else{
      return (
        <Spinner />
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Slider/responsive.js